import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as CheckCircleFilled } from '../../../assets/images/icons/check_circle_filled_yellow.svg';
import * as types from '../../../types';
import styles from './WhatsIncluded.module.scss';

interface WhatsIncludedProps {
  productCategory?: types.ProductCategory;
}

export default function WhatsIncluded({ productCategory }: WhatsIncludedProps) {
  const { t } = useTranslation();
  const trackerKey =
    productCategory === types.ProductCategory.MINI ? 'referral_v2_mini_gps_tracker' : 'referral_v2_series3_gps_tracker';

  const items = [
    t(trackerKey),
    t('referral_v2_30_days_free'),
    t('referral_v2_cancel_anytime'),
    t('referral_v2_unlimited_gps_tracking'),
  ];

  return (
    <div className={styles.container}>
      <div className={styles.heading}>{t('referral_v2_whats_included')}</div>
      <div className={styles.grid}>
        {items.map((item) => (
          <div key={item} className={styles.item}>
            <CheckCircleFilled className={styles.icon} />
            <span>{item}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
